import Logger from 'js-logger';
/**
 * Available keys for Guest app
 */
export enum LsKey {
  EnableLogging = 'enableLogging',
  EnableReduxLogging = 'enableReduxLogging',
  Locale = 'locale',
  A_TOKEN = 'A',
  Settings = 'outlook.webapp.settings',
  LogInUrl = 'logInUrl',
  Appointment = 'appointment',
  DefaultQuickInvite = 'defaultQuickInvite',
}

/**
 * Set a guest app key value from local storage
 * @param key - one of lsKey string enum
 * @param value - new value to set
 */
export const lsSet = (key: LsKey, value: string): void => {
  Logger.info(`Setting ${key} to ${value}`);
  Office.context.roamingSettings.set(key, value);
  Office.context.roamingSettings.saveAsync();
};

/**
 * Get a guest app key value from local storage
 * @param key - one of lsKey string enum
 */
export const lsGet = (key: LsKey): string | null => {
  //  Logger.debug(`Getting ${key}`);
  try {
    return Office.context.roamingSettings.get(key);
  } catch (e) {
    Logger.error(e);
    return '';
  }
};

/**
 * Remove a guest app key from local storage
 * @param key - one of lsKey string enum
 */
export const lsRemove = (key: LsKey): void => {
  Logger.debug(`Removing ${key}`);
  try {
    Office.context.roamingSettings.remove(key);
    Office.context.roamingSettings.saveAsync();
  } catch (e) {
    Logger.error(e);
  }
};
